<div class="w-full flex flex-column gap-3">
  <b class="block w-full text-left font-medium text-xl" style="color: #052647;">Update Photo</b>
  <ul class="w-full flex flex-column gap-3">
    <li class="w-full flex flex-column gap-1">
      <b class="w-full block text-left font-normal text-base" style="color: #575B68;">Update Profile Photo</b>
      <div class="w-full flex p-3 align-items-center justify-content-center border-round-lg "
        style="background-color: #f8f8f8; border:1px solid #ddd">
        <app-image-crop-upload [borderType]="'profile'" [aspectRatio]="1" [imageUrl]="profileImage" [imageClass]="'w-12rem h-12rem'"
        (imageCropped)="onProfileCropped($event)"></app-image-crop-upload>
      </div>
    </li>

    <li class="w-full flex flex-column gap-1" *ngIf="currentPortal !== 'mentor'">
      <b class="w-full block text-left font-normal text-base" style="color: #575B68;">Update Cover Photo</b>
      <div class="w-full flex p-3 align-items-center justify-content-center border-round-lg "
        style="background-color: #f8f8f8; border:1px solid #ddd">
        <app-image-crop-upload [borderType]="'cover'" [aspectRatio]="16/9" [imageUrl]="coverImage" [imageClass]="'w-full h-12rem'"
        (imageCropped)="onCoverCropped($event)"></app-image-crop-upload>
      </div>
    </li>
  </ul>
  <p-button typ="button" styleClass="btn_save" label="Submit" (click)="onSubmit()"></p-button>
</div>
